import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { compose } from 'recompose';
import styled from 'styled-components';
import { hot } from 'react-hot-loader';
import { Link } from 'react-router-dom';

import { Card, Table, Input, Icon, Header, Dimmer, Loader, Breadcrumb, Container, Button } from 'semantic-ui-react';

import { withLocale } from 'op/components/locale';
import { Evaluation } from 'op/components/evaluation';
import { withPersonReports } from './person-reports.helper';
import axios from "axios";
const filterReport = (search, report) => {
  const inputs = search.toLowerCase().split(' ');
  const type = report.type ? report.type.name.toLowerCase() : '';
  const category = report.categoriesArr ? report.categoriesArr.toLowerCase() : '';

  return (report.completed || !report.mobileCreated) && inputs.some(input => type.includes(input) || category.includes(input))
}

const renderReport = (locale, format, report) => (
  <Table.Row key={report.id}>
    <Table.Cell collapsing>
      <Header as='h4' image>
        {moment(report.timestamp).locale('en').format(format)}
      </Header>
    </Table.Cell>
    <Table.Cell>
      <Header as='h4' textAlign={locale._meta.rtl ? 'right' : 'left'}>
        <Header.Content as={Link} to={`/person/${report.person_id}/report/${report.id}`}>
          {report.type && report.type.name}
          <Header.Subheader>{report.category && report.category.name}</Header.Subheader>
        </Header.Content>
      </Header>
    </Table.Cell>
    <Table.Cell collapsing>
      <Evaluation model={report} type={report.type} />
    </Table.Cell>
  </Table.Row>
);

const EmptyPage = styled.div`
  display: flex;

  height: 100%;
  width: 100%;

  align-items: center;
  justify-content: center;

  padding-top: 2rem;
  padding-bottom: 10rem;
`;

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  & > h2 {
    margin: 0 !important;
  }
`;

const LoadMoreContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const PersonReports = ({ locale, search, setSearch, reports, person, loading, shouldFetchMore, fetchPersonReports }) => {
  const [fieldValue, setFieldValue] = useState();
  useEffect(() => {
    setFieldValue("DD/MM/YYYY");
    axios.get('/api/common/terms').then(response => {
      setFieldValue(response.data.dateConvertCode == 103 ? "DD/MM/YYYY" : "MM/DD/YYYY");
    }).catch(ex => console.log(ex.message));
  }, []);
  const [filtered, setFiltered] = useState(reports);
  const [searchInput, setSearchInput] = useState(search);

  useEffect(() => {
    setFiltered(
      reports
        .filter(filterReport.bind(null, search))
        .sort((left, right) => moment(right.timestamp).diff(left.timestamp))
    )
  }, [reports, search]);

  return (
    <Card.Group>
      <Card fluid>
        <Card.Content>
          <Card.Header>
            <Breadcrumb>
              <Breadcrumb.Section link as={Link} to="/">{locale.search}</Breadcrumb.Section>
              <Breadcrumb.Divider />
              <Breadcrumb.Section active>{person.name}</Breadcrumb.Section>
            </Breadcrumb>
            <Loader active={loading == 'partial'} inline size='tiny' style={{ float: locale._meta.rtl ? 'left' : 'right' }} />
          </Card.Header>
          {
            reports && reports.length > 0 &&
            <div>
              <Table basic='very' celled>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell colSpan='3'>
                      <HeaderContainer>
                        <Header as='h2'>{locale.title}</Header>
                        <Input
                          icon='filter'
                          placeholder='Search...'
                          value={searchInput}
                          onChange={(e) => {
                            setSearchInput(e.target.value);
                            setSearch(e.target.value);
                          }} />
                      </HeaderContainer>
                    </Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  {filtered.map(renderReport.bind(null, locale, fieldValue))}
                </Table.Body>
              </Table>
              <LoadMoreContainer>
                <Button
                  loading={!!loading}
                  content="More"
                  primary
                  onClick={() => fetchPersonReports()}
                  disabled={!shouldFetchMore}
                />
              </LoadMoreContainer>
            </div>
          }
          {
            !(reports && reports.length > 0) &&
            <EmptyPage>
              <Header as='h2' icon>
                <Icon name='space shuttle' />
                {locale.empty.header}
                <Header.Subheader>{locale.empty.content}</Header.Subheader>
              </Header>
            </EmptyPage>
          }
        </Card.Content>
        <Dimmer active={loading == 'full'}><Loader content='Loading' /></Dimmer>
      </Card>
    </Card.Group>
  );
}

export default compose(
  hot(module),
  withLocale('report.person'),
  withPersonReports,
)(PersonReports);
